const principles = [
  {
    icon: 'ri-verified-badge-line',
    title: '先核实，后发布',
    desc: '所有报道在发布前经过多方核查，不传播未经验证的信息。我们宁愿慢一步，也不发一条无法核实的内容。',
  },
  {
    icon: 'ri-lock-password-line',
    title: '线索保密原则',
    desc: '投稿人信息严格保密，支持完全匿名投稿。我们对每一位提供线索的人负责，保护信源是编辑部的基本职责。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '客观与平衡',
    desc: '报道前联系各方当事人，尽力呈现完整事实。我们的目标是让公众了解真相，而非制造对立或煽动情绪。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续跟进',
    desc: '对已发布报道的后续进展保持关注，及时更新。一个问题被曝光后，直到它得到真正解决，我们才停止追踪。',
  },
];

export default function PrinciplesSection() {
  return (
    <section className="bg-background-950 py-14 md:py-20" aria-labelledby="principles-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-widest text-primary-400 font-semibold">我们的承诺</span>
          <h2 id="principles-heading" className="font-heading text-2xl md:text-3xl font-bold text-background-50 mt-3 mb-3">
            编辑原则
          </h2>
          <p className="text-background-400 text-sm max-w-lg mx-auto">
            17爆料成立于坚持新闻真实性与公共利益的信念。这四项原则，是我们对每一位读者和投稿人的承诺。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {principles.map((p) => (
            <div key={p.title} className="flex flex-col gap-3 p-5 rounded-lg border border-foreground-800 hover:border-primary-700 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center rounded bg-primary-500/15 text-primary-400">
                <i className={`${p.icon} text-xl`} />
              </div>
              <h3 className="font-heading font-bold text-background-100 text-sm">{p.title}</h3>
              <p className="text-xs text-background-500 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            {
              quote: '通过17爆料投稿之后三天，我所在的小区路灯就修好了，没想到一个平台真的能推动事情发生变化。',
              author: '北京某小区业主',
            },
            {
              quote: '我们给17爆料发了私信，附上了聊天截图和转账记录，编辑回复很快，全程保密，最后报道出来我们才敢公开说。',
              author: '网络诈骗受害者（化名）',
            },
            {
              quote: '看到自己提供的线索最后被核实发布出来，感觉有点激动——原来普通人也可以让真相被更多人看见。',
              author: '17爆料投稿用户',
            },
          ].map((t) => (
            <blockquote key={t.author} className="bg-foreground-900 rounded-lg p-5 border-l-2 border-primary-500">
              <p className="text-sm text-background-300 italic leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
              <footer className="mt-3 text-xs text-background-500">—— {t.author}</footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}